import { scrollIntoView } from '~/framework/utils/scroll';
import { type App } from '~/app';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Stockland Multi Target Tab Component v2');

    const listeners: Array<[Document | Element | Window  , string, EventListenerOrEventListenerObject]> = [];

    app.afterMount
        .then(() => {
            mountMultipleTargetTabsV2(listeners);
        })
        .catch((error) => {
            throw new Error('[Stockland FE] Unable to register Stockland Multi Target Tab Component v2', error);
        });

    return function destroyVerticalScrollCarousel() {
        unMountMultipleTargetTabsV2(listeners);

        app.logger.debug('[DXA] Multi Target Tab v2 Component destroyed');
    };
};

export function mountMultipleTargetTabsV2(
    listeners: Array<[Document | Element | Window  , string, EventListenerOrEventListenerObject]>
) {
    const elements = document.querySelectorAll<HTMLElement>('.multi-target-tabs-v2');

    const toggleTargets = (tab: HTMLElement, element: HTMLElement) => {
        const targets = tab.dataset.target;
        //split the query selector
        const targetArray = targets?.split(',');
        if (targetArray) for (const currentTarget of targetArray) {
            const currentTargetElement = element.querySelector<HTMLElement>(currentTarget);
            const currentActiveElement = currentTargetElement?.parentElement?.querySelector<HTMLElement>('.tab-pane.active');
            //remove all active tabs
            currentActiveElement?.classList.remove('active');
            currentActiveElement?.classList.remove('show');
            //add active tabs to current tab
            currentTargetElement?.classList.add('show');
            currentTargetElement?.classList.add('active');
        }

        const navTabs = element.querySelectorAll<HTMLElement>('.nav-tabs')
        for (const inlineTabs of navTabs) {
            // eslint-disable-next-line @typescript-eslint/no-loop-func,unicorn/consistent-function-scoping
            const scrollTabIntoView = (event: Event) => {
                if (event.target instanceof Element) {
                    scrollIntoView(event.target, {
                        behavior: 'smooth',
                        inline: 'center',
                        block: 'nearest'
                    });
                }
            };
	
            const tabs = inlineTabs.querySelectorAll<HTMLElement>('.nav-link');
            for (const tab of tabs) {
                tab.addEventListener('click', scrollTabIntoView);
                listeners.push([tab, 'click', scrollTabIntoView]);
            }
        }
    };

    const loadRemainingButtons = (buttonLoader: HTMLElement, targets: NodeListOf<HTMLElement>) => {
        for (const target of targets) {
            target.classList.remove('hidden');
            buttonLoader.classList.add('hidden');
        }   
    }

    const initialiseMultipleTargetTabs = (elements: NodeListOf<HTMLElement>) => {
        for (const [index, element] of elements.entries()) {
            const currentTab = element.querySelectorAll<HTMLElement>("[data-bs-toggle='tab']");
            for (const tab of currentTab) {
                tab.addEventListener('show.bs.tab', function () {
                    toggleTargets(tab, element);
                });
                listeners.push([
                    tab,
                    'show.bs.tab',
                    function () {
                        toggleTargets(tab, element);
                    },
                ]);
            }

            const buttonLoader = element.querySelector<HTMLElement>('.btn-lazy-loader');
            if(buttonLoader)
            {
                const targets = element.querySelectorAll<HTMLElement>('.nav-link.hidden'); 
                buttonLoader.addEventListener('click', ()=> loadRemainingButtons(buttonLoader, targets));   
                listeners.push([buttonLoader,'click',()=> loadRemainingButtons(buttonLoader, targets)]);
            }
        }
    }

    initialiseMultipleTargetTabs(elements);

    return { elements };
}

export function unMountMultipleTargetTabsV2(
    listeners: Array<[Document | Element | Window  , string, EventListenerOrEventListenerObject]>
) {
    for (const [element, event, listener] of listeners) {
        element.removeEventListener(event, listener);
    }
}
